import {
  FindOperationChainsQueryParams,
  useFindOperationChains,
} from "~/gen/api"

export const useFindOperationChainsQuery = (
  params: FindOperationChainsQueryParams
) => useFindOperationChains(params)
